export const hotelTypeToPresentationTextMap = {
  boutiqueHotel: 'Boutique Hotel',
  privateVilla: 'Private Villa'
}